// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Election from "./election.js"
import Organization from "./organization.js"
import SchoolClass from "./school-class.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "election_type": {
      "column": {
        "default": null,
        "name": "election_type",
        "null": false,
        "type": "string"
      },
      "name": "election_type",
      "selected_by_default": null,
      "translated": null
    },
    "translated_election_type": {
      "column": null,
      "name": "translated_election_type",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "SchoolElection",
  "collectionKey": "school_elections",
  "collectionName": "school_elections",
  "i18nKey": "school_election",
  "camelizedLower": "schoolElection",
  "name": "SchoolElection",
  "nameDasherized": "school-election",
  "pluralName": "school_elections",
  "ransackable_associations": [
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "creator_id",
      "name": "creator",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "Election",
      "collectionName": "elections",
      "foreignKey": "school_election_id",
      "name": "election",
      "macro": "has_one",
      "resource_name": "Election",
      "through": null
    },
    {
      "className": "ElectionPost",
      "collectionName": "election_posts",
      "foreignKey": "election_id",
      "name": "election_posts",
      "macro": "has_many",
      "resource_name": "ElectionPost",
      "through": "election"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "school_id",
      "name": "school",
      "macro": "belongs_to",
      "resource_name": "Organization",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_classes",
      "macro": "has_many",
      "resource_name": "SchoolClass",
      "through": "election_posts"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "creator_id",
      "column": {
        "default": null,
        "name": "creator_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "election_type",
      "column": {
        "default": null,
        "name": "election_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "ends_at",
      "column": {
        "default": null,
        "name": "ends_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "school_id",
      "column": {
        "default": null,
        "name": "school_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "starts_at",
      "column": {
        "default": null,
        "name": "starts_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Election",
      "collectionName": "elections",
      "foreignKey": "school_election_id",
      "name": "election",
      "macro": "has_one",
      "resource_name": "Election",
      "through": null
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "school_id",
      "name": "school",
      "macro": "belongs_to",
      "resource_name": "Organization",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_classes",
      "macro": "has_many",
      "resource_name": "SchoolClass",
      "through": "election_posts"
    }
  ],
  "paramKey": "school_election",
  "primaryKey": "id"
}

/** Frontend model for SchoolElection. */
export default class SchoolElection extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  electionType() {
    return this.readAttributeUnderscore("election_type")
  }

  /** @returns {boolean} */
  hasElectionType() {
    const value = this.electionType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedElectionType() {
    return this.readAttributeUnderscore("translated_election_type")
  }

  /** @returns {boolean} */
  hasTranslatedElectionType() {
    const value = this.translatedElectionType()

    return this._isPresent(value)
  }

  /** @returns {import("./election.js").default | null} */
  election() {
    return this._readHasOneReflection({modelClass: Election, reflectionName: "election"})
  }

  /** @returns {Promise<import("./election.js").default | null>} */
  loadElection() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["school_election_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "election",
        model: this,
        modelClass: Election
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./election.js").default | null>} */
  ensureElectionLoaded() {
    return this.ensureAssociationLoaded("election")
  }

  /** @returns {import("./organization.js").default | null} */
  school() {
    return this._readBelongsToReflection({modelClass: Organization, reflectionName: "school"})
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  loadSchool() {
    if (!("schoolId" in this)) throw new Error("Foreign key method wasn't defined: schoolId")

    const id = this.schoolId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "school",
        model: this,
        modelClass: Organization
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  ensureSchoolLoaded() {
    return this.ensureAssociationLoaded("school")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class.js").default>} */
  schoolClasses() {
    return new Collection(
      {
        reflectionName: "school_classes",
        model: this,
        modelClass: SchoolClass
      },
      {
        params: {
          through: {
            model: "SchoolElection",
            id: this.primaryKey(),
            reflection: "school_classes"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./school-class.js").default>>} */
  loadSchoolClasses() {
    return this._loadHasManyReflection(
      {
        reflectionName: "school_classes",
        model: this,
        modelClass: SchoolClass
      },
      {
        params: {
          through: {
            model: "SchoolElection",
            id: this.primaryKey(),
            reflection: "school_classes"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./school-class.js").default>>} */
  ensureSchoolClassesLoaded() {
    return this.ensureAssociationLoaded("school_classes")
  }
}
